<template>
  <button
    type="button"
    class="button"
    @click="emit('toggle', item)"
    :class="{ focused: firstPanel && focusedItem?.name === item.name }"
  >
    <ThreePanelConditionCategoryItemAction
      v-if="firstPanel"
      :selected-brands="selectedBrands"
      :brand-select-all-index="brandSelectAllIndex"
      :item="item"
      :prefix="prefix"
      :no-events="noEvents"
      @click.stop="onToggleFirst(item)"
    />
    <ThreePanelConditionCategoryItemActionSubItem
      v-if="!firstPanel"
      :selected-keys-index="selectedKeysIndex"
      :item="item"
      :prefix="prefix"
      :no-events="noEvents"
    />
    <v-tooltip location="top">
      <template #activator="{ props: tooltipProps }">
        <div class="v-list__tile__title" v-bind="tooltipProps">
          {{ item.name }}
        </div>
      </template>
      <span>{{ item.name }}</span>
    </v-tooltip>
  </button>
</template>

<script setup lang="ts">
import ThreePanelConditionCategoryItemAction from './three-panel-condition-category-item-action.vue';
import ThreePanelConditionCategoryItemActionSubItem from './three-panel-condition-category-item-action-sub-item.vue';

const props = defineProps<{
  selectedBrands?: string[];
  brandSelectAllIndex?: Record<string, boolean>;
  selectedKeysIndex?: Record<string, boolean>;
  item: { name: string; data?: string[] };
  prefix: string;
  focusedItem?: { name?: string };
  firstPanel?: boolean;
  noEvents?: boolean;
}>();

const emit = defineEmits<{
  toggle: [item: typeof props.item];
  'select-all': [item: typeof props.item];
}>();

const onToggleFirst = (item: typeof props.item) => {
  emit('toggle', item);
  emit('select-all', item);
};
</script>

<style lang="scss" scoped>
.button {
  display: flex;
  height: 40px;
  border-top: 1px solid var(--color-gray10);
  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
  overflow: hidden;
  text-align: left;
}

.v-list__tile__title {
  flex: 1;
  min-width: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.focused {
  background-color: var(--color-gray10);
}
</style>
